{
  "de": {
    "subscription": {
      "customers": {
        "announcement": {
          "description": "Erhalten Sie eine Benachrichtigung, wenn neue Beiträge veröffentlicht werden.",
          "label": "Neuigkeiten"
        },
        "question": {
          "description": "Erhalten Sie eine Benachrichtigung, wenn neue Fragen im FAQ-Bereich hinzugefügt werden.",
          "label": "FAQ"
        }
      },
      "employees": {
        "aftercare": {
          "description": "Erhalten Sie Benachrichtigungen zu Punkten und Nachbetreuung.",
          "label": "Nachbetreuung"
        },
        "announcement": {
          "description": "Erhalten Sie eine Benachrichtigung, wenn neue Beiträge veröffentlicht werden.",
          "label": "Neuigkeiten"
        },
        "decision": {
          "description": "Erhalten Sie Benachrichtigungen zu Entscheidungen.",
          "label": "Entscheidungen"
        },
        "document": {
          "description": "Erhalten Sie eine Benachrichtigung, wenn neue Dokumente hochgeladen werden.",
          "employee_create": {
            "description": "Erhalten Sie eine Benachrichtigung, wenn Dokumente von anderen Mitarbeitern hochgeladen werden.",
            "label": "Dokumente von Kollegen"
          },
          "label": "Dokumente"
        },
        "email_conversation": {
          "description": "Erhalten Sie eine Benachrichtigung, wenn E-Mails an Ihre Ziggu-Projekte weitergeleitet werden.",
          "label": "E-Mail-Weiterleitung"
        },
        "export": {
          "description": "Erhalten Sie eine Benachrichtigung, wenn Exporte erstellt werden.",
          "label": "Exporte"
        },
        "question": {
          "description": "Erhalten Sie eine Benachrichtigung, wenn neue Fragen im FAQ-Bereich hinzugefügt werden.",
          "label": "FAQ"
        },
        "survey": {
          "description": "Erhalten Sie Benachrichtigungen zu Umfragen.",
          "label": "Umfragen"
        },
        "ticket": {
          "description": "Erhalten Sie Benachrichtigungen zu Konversationen.",
          "label": "Konversationen"
        },
        "todo": {
          "description": "Erhalten Sie eine Benachrichtigung, wenn Ihnen eine Aufgabe als Verantwortlicher zugewiesen wird.",
          "label": "Aufgabenzuweisungen"
        }
      },
      "labels": {
        "email_preferences": "Meine E-Mail-Benachrichtigungseinstellungen",
        "general_preferences": "Meine Benachrichtigungseinstellungen",
        "receiveEmailNotificationsAbout": "E-Mail-Benachrichtigungen erhalten"
      }
    }
  }
}
